import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0B2A57] text-white pt-16 pb-8" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <h3 className="text-xl font-bold mb-3 tracking-wide" style={{ fontFamily: 'Cabinet Grotesk' }}>
              TAIGA SOURCING
            </h3>
            <p className="text-white/60 text-sm leading-relaxed mb-4">
              Bridging global buyers with Indian manufacturers. Multi-category sourcing from India.
            </p>
            <Link
              to="/request-sourcing"
              className="inline-block px-5 py-2 text-xs font-semibold tracking-wider uppercase bg-white/10 border border-white/20 text-white hover:bg-white/20 transition-colors"
            >
              Request Sourcing
            </Link>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 tracking-wider uppercase text-white/80">
              Quick Links
            </h4>
            <ul className="space-y-2">
              {[
                { to: '/categories', label: 'Categories' },
                { to: '/services', label: 'Services' },
                { to: '/how-it-works', label: 'How It Works' },
                { to: '/for-buyers', label: 'For Buyers' },
                { to: '/for-suppliers', label: 'For Suppliers' },
                { to: '/about', label: 'About' },
                { to: '/blog', label: 'Blog' },
                { to: '/contact', label: 'Contact' },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-white/50 hover:text-white text-sm transition-colors"
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 tracking-wider uppercase text-white/80">
              Categories
            </h4>
            <ul className="space-y-2">
              {[
                { to: '/categories/apparel', label: 'Apparel & Fashion' },
                { to: '/categories/tiles', label: 'Tiles & Surfaces' },
                { to: '/categories/bathware', label: 'Bathware & Sanitaryware' },
                { to: '/categories/home-decor', label: 'Home & Decor' },
                { to: '/categories/furniture', label: 'Furniture' },
                { to: '/categories/textiles', label: 'Textiles & Made-Ups' },
                { to: '/categories/handicrafts', label: 'Handicrafts' },
                { to: '/categories/packaging', label: 'Packaging' },
                { to: '/categories/electrical', label: 'Electrical' },
                { to: '/categories/plumbing', label: 'Plumbing Pipes & Fittings' },
                { to: '/categories/chemicals', label: 'Chemicals' },
                { to: '/categories/custom-sourcing', label: 'Custom Sourcing' },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-white/50 hover:text-white text-sm transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 tracking-wider uppercase text-white/80">
              Contact
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Phone size={16} className="mt-0.5 flex-shrink-0 text-white/40" />
                <a href="tel:9099967671" className="text-white/50 hover:text-white text-sm transition-colors" data-testid="footer-phone">
                  +91 90999 67671
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={16} className="mt-0.5 flex-shrink-0 text-white/40" />
                <a href="tel:8099975662" className="text-white/50 hover:text-white text-sm transition-colors">
                  +91 80999 75662
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="mt-0.5 flex-shrink-0 text-white/40" />
                <a href="mailto:info@taigasourcing.com" className="text-white/50 hover:text-white text-sm transition-colors" data-testid="footer-email">
                  info@taigasourcing.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 flex-shrink-0 text-white/40" />
                <span className="text-white/50 text-sm" data-testid="footer-address">
                  B.No. 28, 2nd Floor, H.No. 207, Khatodra Bethi Colony, Surat, Gujarat 395002
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/40 text-xs">
              &copy; {currentYear} Taiga Sourcing. All rights reserved.
            </p>
            <div className="flex items-center gap-6 text-xs">
              <Link to="/terms" className="text-white/40 hover:text-white transition-colors">
                Terms & Conditions
              </Link>
              <Link to="/privacy" className="text-white/40 hover:text-white transition-colors">
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
